import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import ClickAwayListener from '@mui/material/ClickAwayListener';

const InfoTooltip = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipToggle = () => {
    setOpen(!open);
  };
  
  const handleTooltipOpen = () => {
    setOpen(true);
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableTouchListener
          title={title}
        >
          <div 
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} 
            onClick={handleTooltipToggle}
            onMouseEnter={handleTooltipOpen}
            onMouseLeave={handleTooltipClose}
          >
            {children}
            <InfoOutlined style={{ fontSize: 16, verticalAlign: 'middle', marginLeft: '4px' }} />
          </div>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default InfoTooltip;
